import styled from 'styled-components';

const StandardSelectWrapper = styled.div`

`;


export default { StandardSelectWrapper };
